import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";

import {
  Container,
  Row,
  Col,
  Form,
  Table,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";

import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import { TUTOR_ASSIGNMENT_API } from "../../../api/api";

import { AiOutlineRise } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { IoEyeOutline } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
// import { FaArrowRightLong } from "react-icons/fa6";
import {
  FaRegCheckCircle,
  FaSearch,
  FaSort,
  FaSortUp,
  FaSortDown,
} from "react-icons/fa";

//icon images
// import submissionIcon from "../../../assets/submission.png";
// import myassignment from "../../../assets/my-assignments.png";

import allAssignmentsIcon from "../../../assets/all-assignments-icon.png";
import NoOfCoursesIcon from "../../../assets/no-of-courses-icon.png";
// import pendingReviewIcon from "../../../assets/pending-review-icon.png";
// import gradedIcon from "../../../assets/grade-icon.png";
// import averageScoreIcon from "../../../assets/average-score-icon.png";
import noDataAssignment from "../../../assets/student/no-data-assignment.png";

import disableGradeIcon from "../../../assets/disable-grade-icon.png";
import visibleGradeIcon from "../../../assets/visible-grade-icon.png";
import disableViewIcon from "../../../assets/disable-view-icon.png";
import visibleViewIcon from "../../../assets/visible-view-icon.png";

// latesIcons
import allAssignments from "../../../assets/icons/student/assignment.svg";
import NoOfCourses from "../../../assets/icons/student/course.svg";
import pendingReview from "../../../assets/icons/tutor/pending-review.svg";
import graded from "../../../assets/icons/tutor/graded.svg";
import averageScore from "../../../assets/icons/tutor/average-score.svg";

import Nofound from "../../../assets/not-found.png";

// Import the separate Create Assignment modal
import TutorCreateAssignments from "../TutorCreateAssignments/TutorCreateAssignments";

import { initialsFromName } from "../../../utils/getInitials";
import { getPageNumbers } from "../../../utils/pagination";
import { handleApiError } from "../../../utils/apiErrorHandler";
import { useSortableTable } from "../../../hooks/useSortableTable";

import "./TutorAssignments.css";

const TutorAssignments = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("submissions");
  const [cardViewType, setCardViewType] = useState({}); // "course" or "module"

  // assignment
  const [assignmentsCardData, setAssignmentsCardData] = useState([]);
  const [assignmentStats, setAssignmentStats] = useState({});

  //Assignment view submission modal
  const [showViewSubmissionModal, setShowViewSubmissionModal] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [questions, setQuestions] = useState([]);

  //Assignment Delete modal(view submission)
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteAssignment, setSelectedDeleteAssignment] =
    useState(null);

  // My Assignment Tabs
  const [selectedAssignmentStatus, setSelectedAssignmentStatus] =
    useState("All");
  const [showAllAssignments, setShowAllAssignments] = useState(false);

  // Create Assignment modal
  const [showCreateModal, setShowCreateModal] = useState(false);
  // Create Assignment modal edit
  const [editingAssignment, setEditingAssignment] = useState(null);

  //Assignment table
  const [submissionsData, setSubmissionsData] = useState([]);
  const [submissionStats, setSubmissionStats] = useState({});
  // Filters state
  const [selectedCourseFilter, setSelectedCourseFilter] =
    useState("All Courses");
  const [selectedStatusFilter, setSelectedStatusFilter] =
    useState("All Status");

  // Search Course
  const [searchCourse, setSearchCourse] = useState("");
  const [feedbackText, setFeedbackText] = useState("");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);

  // Grade modal
  const [showGradeModal, setShowGradeModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  // Grade view modal
  const [isViewMode, setIsViewMode] = useState(false);

  //loading
  const [deletingLoading, setDeletingLoading] = useState(false);
  const [submissionsLoading, setSubmissionsLoading] = useState(true);
  const [submittingFeedbackLoading, setSubmittingFeedbackLoading] =
    useState(false);

  const token = localStorage.getItem("token");

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  const fetchSubmissions = useCallback(async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setSubmissionsLoading(false);
      navigate("/signin");

      return;
    }

    try {
      const response = await axios.post(
        TUTOR_ASSIGNMENT_API.GET_TUTOR_FINAL_EXAM_STATUS,
        { tutor_id: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        const mappedData = (data.data || []).map((item) => ({
          finalAssignmentId: item.final_assignment_id,
          finalStudent: item.student_name,
          finalCourse: item.course_title?.trim(),
          finalAssignment: item.assignment_title,
          finalSubmitted: item.submitted_at || "-",
          finalScore: item.total_marks || "-",
          finalStatus: item.tutor_status,
        }));

        setSubmissionsData(mappedData);
        setSubmissionStats(data.stats || {});
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error fetching course detail:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    } finally {
      setSubmissionsLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    if (activeTab === "submissions") {
      fetchSubmissions();
    }
  }, [activeTab, fetchSubmissions]);

  const handleViewFinalAssignment = async (finalAssignmentId) => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    try {
      const response = await axios.post(
        TUTOR_ASSIGNMENT_API.GET_FINAL_ASSIGNMENT_BY_ID,
        { final_assignment_id: finalAssignmentId },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        const finalData = data.data;

        setSelectedRow({
          finalAssignmentId: finalData.final_assignment_id,
          finalStudentName: finalData.student_name,
          finalEmail: finalData.email,
          finalCourseTitle: finalData.course_title,
          finalAssignmentTitle: finalData.assignment_title,
          finalSubmitted: finalData.submitted_at,
          finalScore: finalData.total_marks,
          finalGrade: finalData.grade,
          finalFeedback: finalData.feedback || "",
          finalStatus: finalData.tutor_status,
        });

        setFeedbackText(finalData.feedback || "");
        setShowGradeModal(true);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error fetching final assignment:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleSubmitFinalAssignmentFeedback = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setSubmittingFeedbackLoading(false);
      navigate("/signin");

      return;
    }

    if (!/^[A-Za-z].*/.test(feedbackText.trim())) {
      showErrorToast("Feedback must start with at least one letter!");
      setSubmittingFeedbackLoading(false);
      return;
    }

    setSubmittingFeedbackLoading(true);
    try {
      const response = await axios.post(
        TUTOR_ASSIGNMENT_API.UPDATE_TUTOR_FINAL_ASSIGNMENT_FEEDBACK,
        {
          final_assignment_id: selectedRow.finalAssignmentId,
          feedback: feedbackText.trim(),
          tutor_status: "Graded",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        await fetchSubmissions();
        setShowGradeModal(false);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error submting final assignment feedback:", error);
      // Server responded with non-2xx status (like 400, 500)

      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    } finally {
      setSubmittingFeedbackLoading(false);
    }
  };

  const fetchAssignments = useCallback(async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      navigate("/signin");
      return;
    }

    try {
      const response = await axios.post(
        TUTOR_ASSIGNMENT_API.GET_TUTOR_ASSIGNMENT_DETAILS,
        { tutorId: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;
      if (data.statusCode === 200) {
        // Transform API data and store IDs
        const apiData = (data.data || []).map((course) => ({
          courseId: course.course_id,
          courseTitle: course.course_title,
          status: course.status,
          courseTotalModules: course.total_modules,
          courseTotalQuestions: course.total_questions,
          courseTotalMarks: course.course_total_marks,
          assignmentType: course.assignment_type,
          passPercentage: course.pass_percentage,
          date: new Date(course.assignment_date).toLocaleDateString("en-GB"),

          modules: (course.modules || []).map((mod) => ({
            moduleId: mod.module_id,
            moduleTitle: mod.module_title,
            moduleStatus: mod.status,
            assignments: (mod.assignments || []).map((assignment) => ({
              assignmentId: assignment.assignment_id,
              assignmentTitle: assignment.assignment_title,
              assignmentType: assignment.assignment_type,
              totalQuestions: assignment.total_questions,
              totalMarks: assignment.total_marks,
              date: new Date(assignment.assignment_date).toLocaleDateString(
                "en-GB",
              ),
            })),
          })),
        }));

        setAssignmentsCardData(apiData);
        setAssignmentStats(data.stats || {});
      } else {
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error fetching assignments:", error);
      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  }, [navigate]);

  useEffect(() => {
    fetchAssignments();
  }, [fetchAssignments]);

  const handleEditAssignment = async (assignment) => {
    if (!token) {
      navigate("/signin");
      return;
    }

    try {
      // Only rejected assignments can be edited
      const response = await axios.post(
        TUTOR_ASSIGNMENT_API.GET_REJECTED_QUESTIONS,
        { assignment_id: assignment.assignmentId },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        const assignmentData = data.assignment;
        const rejectedQuestions = data.rejectedQuestions || [];

        const mappedQuestions = rejectedQuestions.map((q) => ({
          questionId: q.question_id,
          questionText: q.question,
          options: [q.a, q.b, q.c, q.d],
          correctOptionIndex: ["a", "b", "c", "d"].indexOf(
            q.answer.toLowerCase(),
          ),
          reason: q.reason,
        }));

        setEditingAssignment({
          assignmentId: assignmentData.assignment_id,
          assignmentTitle: assignmentData.assignment_title,
          assignmentType: assignmentData.assignment_type,
          totalQuestions: assignmentData.total_questions,
          totalMarks: assignmentData.total_marks,
          passingPercentage: assignmentData.pass_percentage,
          questions: mappedQuestions,
        });

        setShowCreateModal(true); // open modal
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error(error);
      // Server responded with non-2xx status (like 400, 500)
      // CHECK (expiry / invalid token)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleViewAssignment = async (assignmentId, moduleStatus) => {
    if (!token) {
      navigate("/signin");
      return;
    }

    try {
      const api =
        moduleStatus === "Rejected"
          ? TUTOR_ASSIGNMENT_API.GET_REJECTED_QUESTIONS
          : TUTOR_ASSIGNMENT_API.GET_ASSIGNMENT_BY_ID;

      const response = await axios.post(
        api,
        { assignment_id: assignmentId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        setSelectedAssignment(data.assignment);

        //  Rejected flow
        if (moduleStatus === "Rejected") {
          const rejected = data.rejectedQuestions || [];

          setQuestions(
            rejected.map((q) => ({
              questionId: q.question_id,
              text: q.question,
              options: [
                { key: "a", text: q.a },
                { key: "b", text: q.b },
                { key: "c", text: q.c },
                { key: "d", text: q.d },
              ],
              correctOption: q.answer,
              reason: q.reason,
              questionStatus: q.status,
            })),
          );
        } else {
          const AllQuestions = data.assignment?.questions || [];

          setQuestions(
            AllQuestions.map((q) => ({
              questionId: q.question_id,
              text: q.question,
              options: [
                { key: "a", text: q.a },
                { key: "b", text: q.b },
                { key: "c", text: q.c },
                { key: "d", text: q.d },
              ],
              correctOption: q.answer, // "a", "b", "c", "d"
            })),
          );
        }
        setShowViewSubmissionModal(true);
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Error fetching assignment:", error);
      // Server responded with non-2xx status (like 400, 500)
      handleApiError(error, navigate, showErrorToast, "/signin");
    }
  };

  const handleDeleteAssignment = async (assignmentId) => {
    if (!assignmentId) {
      showErrorToast("Invalid assignment. Cannot delete.");
      return;
    }
    setDeletingLoading(true);

    try {
      const response = await axios.post(
        TUTOR_ASSIGNMENT_API.DELETE_ASSIGNMENT,
        { assignment_id: String(assignmentId) },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });
        setShowDeleteModal(false);
        fetchAssignments();
      } else {
        // This will handle any 2xx response that is not 201
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Delete Assignment Error:", error);
      // Server responded with non-2xx status (like 400, 500)
      handleApiError(error, navigate, showErrorToast, "/signin");
    } finally {
      setDeletingLoading(false);
    }
  };

  // Extract unique courses for the dropdown
  const filteredCoursesForDropdown = useMemo(() => {
    return [...new Set(submissionsData.map((r) => r.finalCourse))];
  }, [submissionsData]);

  // tutor depending on course
  const filteredStatusForDropdown = useMemo(() => {
    return selectedCourseFilter === "All Courses"
      ? [...new Set(submissionsData.map((r) => r.finalStatus))] // all statuses
      : [
          ...new Set(
            submissionsData
              .filter((r) => r.finalCourse === selectedCourseFilter)
              .map((r) => r.finalStatus),
          ),
        ];
  }, [submissionsData, selectedCourseFilter]);

  const clearFilters = () => {
    setSelectedCourseFilter("All Courses");
    setSelectedStatusFilter("All Status");
    setSearchCourse("");
    setCurrentPage(1);
  };

  // Filter rows based on selected course and status submission tab
  const filteredRows = useMemo(() => {
    return submissionsData.filter(
      (r) =>
        (selectedCourseFilter === "All Courses" ||
          r.finalCourse === selectedCourseFilter) &&
        (selectedStatusFilter === "All Status" ||
          r.finalStatus === selectedStatusFilter) &&
        (r.finalCourse
          .toLowerCase()
          .includes(searchCourse.trim().toLowerCase()) ||
          r.finalStudent
            .toLowerCase()
            .includes(searchCourse.trim().toLowerCase())),
    );
  }, [
    submissionsData,
    selectedCourseFilter,
    selectedStatusFilter,
    searchCourse,
  ]);

  const { sortedData, sortConfig, handleSort } = useSortableTable(filteredRows);

  const rowsPerPage = 5;
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
    if (totalPages === 0) {
      setCurrentPage(1);
    }
  }, [filteredRows, totalPages, currentPage]);

  //  SORT ICON HELPER
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort size={11} />;
    if (sortConfig.direction === "asc") return <FaSortUp size={11} />;
    return <FaSortDown size={11} />;
  };

  // function call
  const pages = getPageNumbers(currentPage, totalPages);

  // Filter assignments based on selected status
  const filteredAssignments =
    selectedAssignmentStatus === "All"
      ? assignmentsCardData
      : assignmentsCardData
          .map((course) => ({
            ...course,
            // Keep only modules that match the selected status
            modules: course.modules.filter(
              (module) => module.moduleStatus === selectedAssignmentStatus,
            ),
          }))
          // Keep only courses that still have modules after filtering
          .filter((course) => course.modules.length > 0);

  //  view all or view less assignments
  const assignmentsToDisplay = showAllAssignments
    ? filteredAssignments
    : filteredAssignments.slice(0, 5);

  return (
    <Container className="tutor-assignment-container">
      <div className="tutor-assignment-header-row">
        <div className="tutor-assignment-title-block">
          <h2 className="tutor-assignment-title">Assignments</h2>
          <p className="tutor-assignment-sub-title">
            Create assignments, review submissions, and assign grades.
          </p>
        </div>
        <Button
          className="tutor-assignment-create-btn"
          onClick={() => setShowCreateModal(true)}
        >
          + Create Assignment
        </Button>
      </div>

      {/* Tabs */}
      <div className="tutor-assignment-tabs-row">
        <Button
          className={`tutor-assignment-tab ${
            activeTab === "submissions" ? "active" : ""
          }`}
          onClick={() => setActiveTab("submissions")}
        >
          <div className="tutor-assignment-tab-content">
            {/* <img
              src={submissionIcon}
              className="tutor-assignment-icon"
              alt="submission-icon"
            /> */}
            <span className="tutor-assignment-tab-text">Submissions</span>
            {/* <span className="tutor-assignment-badge-count">01</span> */}
          </div>
        </Button>

        <Button
          className={`tutor-assignment-tab ${
            activeTab === "myassignments" ? "active" : ""
          }`}
          onClick={() => setActiveTab("myassignments")}
        >
          <div className="tutor-assignment-tab-content">
            {/* <img
              src={myassignment}
              className="tutor-assignment-icon"
              alt="my-assignment-icon"
            /> */}
            <span className="tutor-assignment-tab-text">My Assignments</span>
          </div>
        </Button>
      </div>

      {activeTab === "myassignments" && (
        <>
          {assignmentsCardData.length === 0 ? (
            <div className="tutor-assignment-empty-box">
              <div className="tutor-assignment-empty-content">
                <img
                  src={noDataAssignment}
                  alt="no-assignments"
                  className="tutor-assignment-empty-icon"
                />
                <h5>No assignments created yet</h5>
                <p>Click 'Create Assignment' to design your first assignment</p>

                {/* <Button
                  className="tutor-my-assignment-create-btn"
                  onClick={() => setShowCreateModal(true)}
                >
                  + Create Assignment
                </Button> */}
              </div>
            </div>
          ) : (
            <>
              {/* Info Cards Row */}
              <Row
                className="tutor-assignment-cards-row"
                style={{ gap: "0px" }}
              >
                <Col lg={3} md={4} sm={6} xs={12}>
                  <div className="tutor-myassignment-info-card">
                    <h6>No.of Assignment</h6>
                    <img
                      src={allAssignments}
                      alt="Assignments"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(assignmentStats.total_assignments) || "-"}</h3>
                    <span className="tutor-assignment-card-link-green">
                      Completed this week
                    </span>
                  </div>
                </Col>

                <Col lg={3} md={4} sm={6} xs={12}>
                  <div className="tutor-myassignment-info-card">
                    <h6>Published</h6>
                    <img
                      src={allAssignmentsIcon}
                      alt="All Assignments Icon"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(assignmentStats.published_assignments) || "-"}</h3>
                    <span className="tutor-assignment-card-link-blue">
                 
                      <AiOutlineRise />
                      +23 this week
                    </span>
                  </div>
                </Col>

                <Col lg={3} md={4} sm={6} xs={12}>
                  <div className="tutor-myassignment-info-card">
                    <h6>Pending</h6>
                    <img
                      src={pendingReview}
                      alt="Pending Icon"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(assignmentStats.pending_assignments) || "-"}</h3>
                    <span className="tutor-assignment-card-link-yellow">
                      Requires evaluation
                    </span>
                  </div>
                </Col>

                <Col lg={3} md={4} sm={6} xs={12}>
                  <div className="tutor-myassignment-info-card">
                    <h6>Rejected</h6>
                    <img
                      src={NoOfCoursesIcon}
                      alt="Courses Icon"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(assignmentStats.rejected_assignments) || "-"}</h3>
                    <span className="tutor-assignment-card-link-green">
                      2 more Added this week
                    </span>
                  </div>
                </Col>
              </Row>

              {/* My Created Assignments Section */}
              <div className="tutor-my-created-assignments">
                <h5>My Created Assignments</h5>

                <div className="tutor-my-created-assignments-status-tabs-row">
                  {[
                    "All",
                    "Published",
                    "Pending",
                    // "Saved Draft",
                    "Rejected",
                  ].map((status) => (
                    <Button
                      key={status}
                      className={`tutor-my-created-assignments-status-tab ${
                        selectedAssignmentStatus === status ? "active" : ""
                      }`}
                      onClick={() => {
                        setSelectedAssignmentStatus(status);
                        setShowAllAssignments(false);
                      }}
                    >
                      {status}
                    </Button>
                  ))}
                </div>

                {filteredAssignments.length === 0 ? (
                  <div className="tutor-assignment-empty-box">
                    <div className="tutor-assignment-empty-content">
                      <img
                        src={noDataAssignment}
                        alt="no-assignments"
                        className="tutor-assignment-empty-icon"
                      />
                      <h6 className="tutor-assignment-empty-box-p">
                        No assignments found for {selectedAssignmentStatus}
                      </h6>
                    </div>
                  </div>
                ) : (
                  <>
                    {/* Display limited or all assignments */}
                    {assignmentsToDisplay.map((courseData) => (
                      <div
                        key={courseData.courseId}
                        className="tutor-my-created-assignment-card"
                      >
                        <div className="tutor-my-created-assignment-card-header">
                          <h6>{courseData.courseTitle}</h6>
                          <span
                            className={`tutor-my-created-assignment-card-status ${
                              courseData.status === "Pending"
                                ? "tutor-my-created-assignment-status-pending"
                                : courseData.status === "Published"
                                  ? "tutor-my-created-assignment-status-published"
                                  : // : courseData.status === "Saved Draft"
                                    // ? "tutor-my-created-assignment-status-saved-draft"
                                    "tutor-my-created-assignment-status-rejected"
                            }`}
                          >
                            {courseData.status}
                          </span>
                        </div>

                        <div className="tutor-assignment-tabs-row mt-3 mb-2">
                          <Button
                            onClick={() =>
                              setCardViewType((prev) => ({
                                ...prev,
                                [courseData.courseId]: "course",
                              }))
                            }
                            className={`tutor-assignment-tab ${
                              cardViewType[courseData.courseId] !== "module"
                                ? "active"
                                : ""
                            }`}
                          >
                            Course
                          </Button>
                          <Button
                            onClick={() =>
                              setCardViewType((prev) => ({
                                ...prev,
                                [courseData.courseId]: "module",
                              }))
                            }
                            className={`tutor-assignment-tab ${
                              cardViewType[courseData.courseId] === "module"
                                ? "active"
                                : ""
                            }`}
                          >
                            Modules
                          </Button>
                        </div>

                        <div className="tutor-mycourse-main-section">
                          {cardViewType[courseData.courseId] !== "module" ? (
                            <div className="tutor-my-created-assignment-card-info-grid">
                              <div className="tutor-my-created-assignment-info-box">
                                <p>Total Modules</p>
                                <h6>{courseData.courseTotalModules}</h6>
                              </div>
                              <div className="tutor-my-created-assignment-info-box">
                                <p>Total Questions</p>
                                <h6>{courseData.courseTotalQuestions}</h6>
                              </div>
                              <div className="tutor-my-created-assignment-info-box">
                                <p>Total Marks</p>
                                <h6>{courseData.courseTotalMarks}</h6>
                              </div>
                              <div className="tutor-my-created-assignment-info-box">
                                <p>Type</p>
                                <h6>{courseData.assignmentType}</h6>
                              </div>
                              <div className="tutor-my-created-assignment-info-box">
                                <p>Passing Percentage</p>
                                <h6>{courseData.passPercentage}%</h6>
                              </div>
                              <div className="tutor-my-created-assignment-info-box">
                                <p>Date</p>
                                <h6>{courseData.date}</h6>
                              </div>
                            </div>
                          ) : (
                            <div className="mt-3">
                              {courseData.modules.map((moduleData) =>
                                moduleData.assignments.map((assignment) => (
                                  <div
                                    key={assignment.assignmentId}
                                    className="tutor-mycourse-module-card mb-3 p-3"
                                  >
                                    <div className="tutor-my-created-assignment-card-actions-header">
                                      <p className="tutor-my-created-assignment-card-subtitle">
                                        {assignment.assignmentTitle} - (
                                        {moduleData.moduleTitle})
                                      </p>

                                      <div className="tutor-my-created-assignment-card-actions">
                                        <span
                                          className={`tutor-my-created-assignment-card-status me-3 ${
                                            moduleData.moduleStatus ===
                                            "Pending"
                                              ? "tutor-my-created-assignment-status-pending"
                                              : moduleData.moduleStatus ===
                                                  "Published"
                                                ? "tutor-my-created-assignment-status-published"
                                                : // : moduleData.moduleStatus ===
                                                  //   "Saved Draft"
                                                  // ? "tutor-my-created-assignment-status-saved-draft"
                                                  "tutor-my-created-assignment-status-rejected"
                                          }`}
                                        >
                                          {moduleData.moduleStatus}
                                        </span>
                                        {moduleData.moduleStatus ===
                                          "Rejected" && (
                                          <button
                                            className="tutor-my-created-assignment-edit-actions-btn"
                                            title="Edit"
                                            onClick={() =>
                                              handleEditAssignment(assignment)
                                            }
                                          >
                                            <FiEdit />
                                          </button>
                                        )}
                                        <button
                                          className="tutor-my-created-assignment-view-actions-btn"
                                          title="View"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleViewAssignment(
                                              assignment.assignmentId,
                                              moduleData.moduleStatus,
                                            );
                                          }}
                                        >
                                          <IoEyeOutline />
                                        </button>

                                        {moduleData.moduleStatus ===
                                          "Pending" && (
                                          <button
                                            className="tutor-my-created-assignment-delete-actions-btn"
                                            title="Delete"
                                            onClick={() => {
                                              setSelectedDeleteAssignment(
                                                assignment,
                                              );
                                              setShowDeleteModal(true);
                                            }}
                                          >
                                            <MdDeleteOutline />
                                          </button>
                                        )}
                                      </div>
                                    </div>

                                    <div className="tutor-my-created-assignment-card-info-grid">
                                      <div className="tutor-my-created-assignment-info-box">
                                        <p>Total Questions</p>
                                        <h6>{assignment.totalQuestions}</h6>
                                      </div>
                                      <div className="tutor-my-created-assignment-info-box">
                                        <p>Total Marks</p>
                                        <h6>{assignment.totalMarks}</h6>
                                      </div>
                                      <div className="tutor-my-created-assignment-info-box">
                                        <p>Date</p>
                                        <h6>{assignment.date}</h6>
                                      </div>
                                    </div>
                                  </div>
                                )),
                              )}
                            </div>
                          )}

                          {/* <div className="tutor-my-created-assignment-bottom">
                            <p>Submission received</p>
                            <div className="tutor-my-created-assignment-bottom-row">
                              <h6>{item.submissions}</h6>
                              <button
                                type="button"
                                className={`tutor-my-created-assignment-card-view-submission ${
                                  item.status === "Pending"
                                    ? "tutor-my-created-assignment-view-submission-pending"
                                    : item.status === "Published"
                                    ? "tutor-my-created-assignment-view-submission-published"
                                    : item.status === "Saved Draft"
                                    ? "tutor-my-created-assignment-view-submission-saved-draft"
                                    : "tutor-my-created-assignment-view-submission-rejected"
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedAssignment(item);
                                  setShowViewSubmissionModal(true);
                                }}
                              >
                                View Submission <FaArrowRightLong />
                              </button>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    ))}

                    {/* Show All / View Less button */}
                    {filteredAssignments.length > 5 && (
                      <div className="tutor-my-created-assignments-view-all-btn">
                        <button
                          onClick={() =>
                            setShowAllAssignments(!showAllAssignments)
                          }
                        >
                          {showAllAssignments ? "View Less" : "View All"}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}

      {activeTab === "submissions" && (
        <>
          {submissionsLoading ? (
            <div className="text-center my-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <>
              {/* cards */}
              <Row className="tutor-assignment-cards-row">
                <Col lg={2} md={4} sm={6} xs={12}>
                  <div className="tutor-assignment-info-card">
                    <h6  className="tutor-assignment-info-card-h6">Courses Purchased</h6>
                    <img
                      src={NoOfCourses}
                      alt="Courses"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(submissionStats.total_purchased_courses) || "-"}</h3>
                    <span className="tutor-assignment-card-link-blue">
                      <AiOutlineRise />
                      +23 this week
                    </span>
                  </div>
                </Col>

                <Col lg={2} md={4} sm={6} xs={12}>
                  <div className="tutor-assignment-info-card">
                    <h6  className="tutor-assignment-info-card-h6">No. of Final Assignments</h6>
                    <img
                      src={allAssignments}
                      alt="All Assignments"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(submissionStats.all_assignments) || "-"}</h3>
                    <span className="tutor-assignment-card-link-green">
                      2 more Added this week
                    </span>
                  </div>
                </Col>

                <Col lg={2} md={4} sm={6} xs={12}>
                  <div className="tutor-assignment-info-card">
                    <h6
                      className="tutor-assignment-info-card-h6"
                      title="Final Assignment Submission"
                    >
                      Final Assignments Submission
                    </h6>
                    <img
                      src={graded}
                      alt="Graded"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(submissionStats.completed_assignments) || "-"}</h3>
                    <span className="tutor-assignment-card-link-green">
                      Completed this week
                    </span>
                  </div>
                </Col>

                <Col lg={2} md={4} sm={6} xs={12}>
                  <div className="tutor-assignment-info-card">
                    <h6  className="tutor-assignment-info-card-h6">Graded Assignments</h6>
                    <img
                      src={averageScore}
                      alt="grades assignment"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(submissionStats.graded) || "-"}</h3>
                    <span className="tutor-assignment-card-link-blue">
                      Course performance
                    </span>
                  </div>
                </Col>

                <Col lg={2} md={4} sm={6} xs={12}>
                  <div className="tutor-assignment-info-card">
                    <h6
                      className="tutor-assignment-info-card-h6"
                      title="Pending Grading Assignments"
                    >
                      Pending Grading Assignments
                    </h6>
                    <img
                      src={pendingReview}
                      alt="review"
                      className="tutor-assignment-info-card-icon"
                    />
                    <h3>{Number(submissionStats.pending_assignments) || "-"}</h3>
                    <span className="tutor-assignment-card-link-yellow">
                      Requires evaluation
                    </span>
                  </div>
                </Col>


              </Row>

              {/* Filters */}
              <Row className="tutor-assignment-filters-row">
                <Col md={7} className="tutor-assignment-filter-col">
                  {/* Search Input */}
                  <div className="tutor-assignment-filter-search-wrap">
                    <input
                      type="text"
                      className="tutor-assignment-filter-search-input"
                      placeholder="Search by course"
                      value={searchCourse}
                      onChange={(e) => setSearchCourse(e.target.value)}
                    />
                    <span className="tutor-assignment-filter-search-icon">
                      <FaSearch />
                    </span>
                  </div>

                  <div className="tutor-assignment-filters-wrapper">
                    {/* Course Filter */}
                    <Form.Select
                      value={selectedCourseFilter}
                      onChange={(e) => {
                        setSelectedCourseFilter(e.target.value);
                        // setSelectedStatusFilter("All Status");
                      }}
                      className="tutor-assignment-filter-select"
                    >
                      <option value="All Courses">All Courses</option>
                      {filteredCoursesForDropdown.map((course, idx) => (
                        <option key={idx} value={course}>
                          {course}
                        </option>
                      ))}
                    </Form.Select>

                    {/* status Filter */}
                    <Form.Select
                      value={selectedStatusFilter}
                      onChange={(e) => setSelectedStatusFilter(e.target.value)}
                      className="tutor-assignment-filter-select"
                    >
                      <option value="All Status">All Status</option>
                      {filteredStatusForDropdown.map((status, idx) => (
                        <option key={idx} value={status}>
                          {status}
                        </option>
                      ))}
                    </Form.Select>

                    <div className="tutor-assignment-clear-filters">
                      <button onClick={clearFilters}>Clear Filters</button>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* table */}
              <div className="tutor-assignment-table-box">
                <Table className="tutor-assignment-table px-5">
                  <thead>
                    <tr>
                      <th
                        className="tutor-assignment-table-header"
                        onClick={() => handleSort("finalStudent")}
                      >
                        Student {renderSortIcon("finalStudent")}
                      </th>
                      <th
                        className="tutor-assignment-table-header"
                        onClick={() => handleSort("finalCourse")}
                      >
                        Course {renderSortIcon("finalCourse")}
                      </th>
                      <th className="tutor-assignment-table-header">
                        Assignment
                      </th>
                      <th
                        className="tutor-assignment-table-header"
                        onClick={() => handleSort("finalSubmitted")}
                      >
                        Submitted {renderSortIcon("finalSubmitted")}
                      </th>
                      <th
                        className="tutor-assignment-table-header"
                        onClick={() => handleSort("finalScore")}
                      >
                        Score {renderSortIcon("finalScore")}
                      </th>
                      <th
                        className="tutor-assignment-table-header"
                        onClick={() => handleSort("finalStatus")}
                      >
                        Status {renderSortIcon("finalStatus")}
                      </th>
                      <th className="tutor-assignment-table-header">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentRows.length === 0 ? (
                      <tr>
                        <td
                          colSpan={12}
                          className="tutor-assignment-table-empty"
                        >
                          <img
                            src={Nofound}
                            alt="No Data Found"
                            className="tutor-assignment-table-empty-img"
                          />
                          <p>No Data Found</p>
                        </td>
                      </tr>
                    ) : (
                      currentRows.map((r, i) => (
                        <tr key={r.finalAssignmentId}>
                          <td title={r.finalStudent}>{r.finalStudent}</td>
                          <td title={r.finalCourse}>{r.finalCourse}</td>
                          <td title={r.finalAssignment}>{r.finalAssignment}</td>
                          <td title={r.finalSubmitted}>{r.finalSubmitted}</td>
                          <td title={r.finalScore}>{r.finalScore}</td>
                          <td title={r.finalStatus}>
                            <span
                              className={
                                r.finalStatus === "Graded"
                                  ? "tutor-assignment-status tutor-assignment-graded"
                                  : "tutor-assignment-status tutor-assignment-pending"
                              }
                            >
                              {r.finalStatus}
                            </span>
                          </td>

                          <td className="tutor-assignment-table-actions">
                            {/* Conditional icons */}
                            <img
                              src={
                                r.finalStatus === "Graded"
                                  ? disableGradeIcon
                                  : visibleGradeIcon
                              }
                              alt="Grade Icon"
                              className="tutor-assignment-table-grade-icon"
                              onClick={() => {
                                if (r.finalStatus !== "Graded") {
                                  handleViewFinalAssignment(
                                    r.finalAssignmentId,
                                  );
                                  setIsViewMode(false);
                                }
                              }}
                            />
                            <img
                              src={
                                r.finalStatus === "Graded"
                                  ? visibleViewIcon
                                  : disableViewIcon
                              }
                              alt="View Icon"
                              className="tutor-assignment-table-view-icon"
                              onClick={() => {
                                if (r.finalStatus === "Graded") {
                                  handleViewFinalAssignment(
                                    r.finalAssignmentId,
                                  );
                                  setIsViewMode(true);
                                }
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>

              {/* Pagination Controls */}
              {totalPages > 1 && (
                <div className="tutor-assignment-table-pagination">
                  <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>

                  {pages.map((page, idx) =>
                    page === "..." ? (
                      <span key={idx} style={{ padding: "0 3px" }}>
                        ...
                      </span>
                    ) : (
                      <Button
                        key={idx}
                        active={currentPage === page}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </Button>
                    ),
                  )}
                  <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </div>
              )}
            </>
          )}
        </>
      )}

      {/* view final assigment grade and submit the feedback */}
      <Modal
        show={showGradeModal}
        onHide={() => setShowGradeModal(false)}
        centered
        size="lg"
        className="tutor-assignment-evaluate-modal p-0"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="tutor-assignment-evaluate-modal-header">
          <button
            className="tutor-assignment-evaluate-modal-close-btn"
            onClick={() => setShowGradeModal(false)}
            aria-label="Close"
          >
            ✕
          </button>
          <div className="tutor-assignment-evaluate-modal-title-block">
            <h5>Evaluate Assignment</h5>
            <p className="tutor-assignment-evaluate-modal-subtitle">
              Review the submission and provide a grade with feedback
            </p>
          </div>
        </Modal.Header>

        <Modal.Body>
          {selectedRow && (
            <>
              {/* USER BOX */}
              <div className="tutor-assignment-evaluate-modal-user-box">
                <div className="tutor-assignment-evaluate-modal-avatar">
                  {initialsFromName(selectedRow.finalStudentName)}
                </div>

                <div>
                  <h6
                    className="tutor-assignment-evaluate-modal-user-name"
                    title={selectedRow.finalStudentName}
                  >
                    {selectedRow.finalStudentName}
                  </h6>
                  <p
                    className="tutor-assignment-evaluate-modal-user-email"
                    title={selectedRow.finalEmail}
                  >
                    {selectedRow.finalEmail || "-"}
                  </p>
                </div>
              </div>

              {/* COURSE / ASSIGNMENT */}
              <div className="tutor-assignment-evaluate-modal-grid-2">
                <div className="tutor-assignment-evaluate-modal-group">
                  <label>Course</label>
                  <input
                    type="text"
                    value={selectedRow.finalCourseTitle}
                    readOnly
                    className="tutor-assignment-evaluate-modal-input-read-only"
                    title={selectedRow.finalCourseTitle}
                  />
                </div>

                <div className="tutor-assignment-evaluate-modal-group">
                  <label>Assignment</label>
                  <input
                    type="text"
                    value={selectedRow.finalAssignmentTitle}
                    readOnly
                    className="tutor-assignment-evaluate-modal-input-read-only"
                    title={selectedRow.finalAssignmentTitle}
                  />
                </div>
              </div>

              {/* SUBMITTED DATE */}
              <div className="tutor-assignment-evaluate-modal-group">
                <label>Submitted</label>
                <input
                  type="text"
                  value={selectedRow.finalSubmitted || "-"}
                  readOnly
                  className="tutor-assignment-evaluate-modal-input-read-only"
                />
              </div>

              <div
                className={
                  isViewMode
                    ? "tutor-assignment-evaluate-modal-group"
                    : "tutor-assignment-evaluate-modal-group-edit"
                }
              >
                <label>Score (out of 100)</label>
                <input
                  type="number"
                  value={selectedRow.finalScore || "-"}
                  readOnly
                  className={
                    isViewMode
                      ? "tutor-assignment-evaluate-modal-input-read-only"
                      : ""
                  }
                />
              </div>

              <div
                className={
                  isViewMode
                    ? "tutor-assignment-evaluate-modal-group"
                    : "tutor-assignment-evaluate-modal-group-edit"
                }
              >
                <label> Grade ( A+ ≥ 80, B ≥ 60, C ≥ 40 )</label>
                <input
                  type="text"
                  value={selectedRow.finalGrade || "-"}
                  readOnly
                  className={
                    isViewMode
                      ? "tutor-assignment-evaluate-modal-input-read-only"
                      : ""
                  }
                />
              </div>

              <div
                className={
                  isViewMode
                    ? "tutor-assignment-evaluate-modal-group"
                    : "tutor-assignment-evaluate-modal-group-edit"
                }
              >
                <label>Feedback</label>
                <textarea
                  rows={3}
                  value={feedbackText}
                  onChange={(e) => setFeedbackText(e.target.value)}
                  readOnly={isViewMode}
                  className={
                    isViewMode
                      ? "tutor-assignment-evaluate-modal-input-read-only"
                      : ""
                  }
                ></textarea>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          {isViewMode ? (
            <Button
              className="tutor-myassignment-view-close-btn-footer"
              onClick={() => setShowGradeModal(false)}
            >
              Close
            </Button>
          ) : (
            <>
              <Button
                className="tutor-assignment-evaluate-modal-submit-btn"
                onClick={handleSubmitFinalAssignmentFeedback}
                disabled={submittingFeedbackLoading}
              >
                {submittingFeedbackLoading ? "Submitting..." : "Submit Grade"}
              </Button>
              {/* <Button className="tutor-assignment-evaluate-modal-re-btn">
                Resubmission
              </Button> */}
            </>
          )}
        </Modal.Footer>
      </Modal>

      {/* view regualr assigment with question and answer */}
      <Modal
        show={showViewSubmissionModal}
        onHide={() => setShowViewSubmissionModal(false)}
        centered
        size="md"
        className="tutor-myassignment-view-submission-modal p-0"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="tutor-myassignment-view-submission-modal-header">
          <button
            className="tutor-myassignment-view-submission-modal-close-btn"
            onClick={() => setShowViewSubmissionModal(false)}
            aria-label="Close"
          >
            ✕
          </button>
          <div>
            <h5 className="tutor-myassignment-view-submission-modal-title">
              View Assignment{" "}
              <span
                className={`tutor-myassignment-view-status-modal ${
                  selectedAssignment?.status === "Pending"
                    ? "tutor-myassignment-modal-status-pending"
                    : selectedAssignment?.status === "Published"
                      ? "tutor-myassignment-modal-status-published"
                      : // : selectedAssignment?.status === "Saved Draft"
                        // ? "tutor-myassignment-modal-status-saved-draft"
                        "tutor-myassignment-modal-status-rejected"
                }`}
              >
                {selectedAssignment?.status}
              </span>
            </h5>
            <p className="tutor-assignment-evaluate-modal-subtitle">
              Review the submission and provide a grade with feedback
            </p>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="tutor-assignment-evaluate-modal-grid-2">
            <div className="tutor-myassignment-view-submission-modal-group">
              <label>Assignment Title</label>
              <p>{selectedAssignment?.assignment_title}</p>
            </div>

            <div className="tutor-myassignment-view-submission-modal-group">
              <label>Type</label>
              <p>{selectedAssignment?.assignment_type}</p>
            </div>
          </div>

          <div className="tutor-myassignment-view-scoring-details-section">
            <p className="tutor-myassignment-view-scoring-details-title">
              Scoring Details
            </p>
            <div className="tutor-myassignment-view-scoring-details">
              <div className="tutor-myassignment-view-scoring-detail-item">
                <label>Total Questions</label>
                <p>{selectedAssignment?.total_questions}</p>
              </div>
              <div className="tutor-myassignment-view-scoring-detail-item">
                <label>Total Marks</label>
                <p>{selectedAssignment?.total_marks}</p>
              </div>
              <div className="tutor-myassignment-view-scoring-detail-item">
                <label>Passing Percentage</label>
                <p>{selectedAssignment?.pass_percentage}%</p>
              </div>
            </div>
          </div>

          {/* Feedback - show only if status is Rejected */}
          {selectedAssignment?.status === "Rejected" && (
            <div className="tutor-myassignment-view-feedback-section">
              <label>Reason for Rejection</label>
              {selectedAssignment?.reason ? (
                selectedAssignment.reason.split("\n").map((line, index) => (
                  <p
                    key={index}
                    className="tutor-myassignment-view-reason-item"
                  >
                    {line}
                  </p>
                ))
              ) : (
                <p>No rejection reason provided</p>
              )}
              {/* {questions.length > 0 ? (
                questions.map((q, index) => (
                  <p key={q.questionId}>
                    <strong>Q{index + 1}:</strong> {q.reason}
                  </p>
                ))
              ) : (
                <p>No feedback provided</p>
              )} */}
            </div>
          )}

          {/* Questions List (example 4 questions) */}
          <div className="tutor-myassignment-view-questions-list">
            {questions.map((q, idx) => (
              <div
                key={q.questionId}
                className="tutor-myassignment-view-question-card"
              >
                <div className="tutor-myassignment-view-question-top-row">
                  <div className="tutor-myassignment-view-question-number">{`0${
                    idx + 1
                  }`}</div>
                  <div className="tutor-myassignment-view-question-text">
                    {q.text}
                  </div>
                </div>

                <div className="tutor-myassignment-view-question-options">
                  {q.options.map((opt) => (
                    <label
                      key={opt.key}
                      className="tutor-myassignment-view-option-label"
                    >
                      <FaRegCheckCircle
                        className={`tutor-myassignment-view-question-option-icon ${
                          opt.key === q.correctOption ? "correct" : "incorrect"
                        }`}
                      />
                      {opt.text}
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <p className="tutor-myassignment-view-creation-date">
            {/* Created on November 17, 2025 at 05:34 PM */}
            Created on{" "}
            {selectedAssignment
              ? new Date(selectedAssignment.assignment_date).toLocaleString(
                  "en-GB",
                  { dateStyle: "medium" },
                )
              : "-"}
          </p>
          <button
            className="tutor-myassignment-view-close-btn-footer"
            onClick={() => setShowViewSubmissionModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* Delete assigment */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        className="tutor-myassignment-delete-modal p-0"
      >
        <Modal.Header className="tutor-myassignment-delete-modal-header">
          <button
            className="tutor-myassignment-delete-modal-close-btn"
            onClick={() => setShowDeleteModal(false)}
            aria-label="Close"
          >
            ✕
          </button>

          <div className="tutor-myassignment-delete-modal-title">
            <h5>Confirm Delete</h5>
          </div>
        </Modal.Header>

        <Modal.Body className="tutor-myassignment-delete-modal-body">
          Are you sure you want to delete this{" "}
          <strong>{selectedDeleteAssignment?.assignmentTitle} </strong>
          assignment?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="tutor-myassignment-modal-cancel-btn-footer"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </Button>

          <Button
            className="tutor-myassignment-modal-delete-btn-footer"
            onClick={() => {
              handleDeleteAssignment(selectedDeleteAssignment?.assignmentId);
            }}
            disabled={deletingLoading}
          >
            {deletingLoading ? "Deleting..." : "Yes, Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Create Assignment Modal */}
      {showCreateModal && (
        <TutorCreateAssignments
          show={showCreateModal}
          onHide={() => {
            setShowCreateModal(false);
            setEditingAssignment(null);
          }}
          editingAssignment={editingAssignment}
          fetchAssignments={fetchAssignments}
        />
      )}
    </Container>
  );
};

export default TutorAssignments;
